/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GroupIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABp0lEQVR4nOWTSUoDQRSGGxXvIIKg6AnEYZcDdN7QQuW9RFyquPUC2egRPIjDypWIiuBwA1diJCoG0UQUNFJlx6GHGEOv9EFTdFfV/9f/vS7P+3cFQWEaWA6RtY4kB/Y9M/EgmB0AlhqyNj8fubPfMzNA0svvBtoEliUvq8rnzRCSnGViwFycBNZ9ZHmwo313JkFhAllfQ/FaV4gcDpbbCO/blhiSbDtz1KmuTk9UXIyyDk+84GVRVijJAFnnXQJUBJYLJN0kEsnlcn1ZI9qJJDvyZ4pjvzKxTUXSPSC9t6Nt7kdCkmosHeklgBn1sqg8yRySPCb06NgY09t2c7lc7iGSkuULJBUgeXYjywawFu38e8LSOLJcx5IEBU0V92dKI8BymtLgZojixK5rmQBpI5JiPVUcSa/ainMoQlIFMMN2H7IsR+YqiVh+PDnHedt9xph+IDn/MlePGTjmvxDHCO9W04H0CUhXYgZAstWNAaTxTjCohJdprTNxcevsbe7QQBtA8uL7ZrATA983g3Z9Iu+kQtZVYN0N09z88AfduHWsu4m8/1S9AYjeryShoMwqAAAAAElFTkSuQmCC)
 */
export const GroupIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.5 8a3 3 0 1 0-2.7-4.3c-.2.4.06.86.44 1.12a5 5 0 0 1 2.14 3.08c.01.06.06.1.12.1ZM18.44 17.27c.15.43.54.73 1 .73h1.06c.83 0 1.5-.67 1.5-1.5a7.5 7.5 0 0 0-6.5-7.43c-.55-.08-.99.38-1.1.92-.06.3-.15.6-.26.87-.23.58-.05 1.3.47 1.63a9.53 9.53 0 0 1 3.83 4.78ZM12.5 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM2 20.5a7.5 7.5 0 0 1 15 0c0 .83-.67 1.5-1.5 1.5a.2.2 0 0 1-.2-.16c-.2-.96-.56-1.87-.88-2.54-.1-.23-.42-.15-.42.1v2.1a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2.1c0-.25-.31-.33-.42-.1-.32.67-.67 1.58-.88 2.54a.2.2 0 0 1-.2.16A1.5 1.5 0 0 1 2 20.5Z"
        className={colorClass}
      />
    </svg>
  );
};
